/**
 * @file
 * Pages a teaser grid in the browser, for grids that opt in with
 * data-pager-size. Without JS every teaser stays visible.
 */

(function (Drupal, once) {
  "use strict";

  Drupal.behaviors.newsBySectionPager = {
    attach: function (context) {
      once("newsBySectionPager", "[data-pager-size]", context).forEach(
        function (items) {
          var size = parseInt(items.getAttribute("data-pager-size"), 10);
          var teasers = Array.prototype.slice.call(items.children);
          if (!size || teasers.length <= size) {
            return;
          }

          var total = Math.ceil(teasers.length / size);
          var buttons = [];

          var nav = document.createElement("nav");
          nav.className = "pager";
          nav.setAttribute("aria-label", Drupal.t("Teaser pagination"));

          var list = document.createElement("ul");
          list.className = "pager__items";
          nav.appendChild(list);

          // Page changes leave focus on the button, so announce them instead.
          var status = document.createElement("p");
          status.className = "visually-hidden";
          status.setAttribute("aria-live", "polite");

          function show(page) {
            teasers.forEach(function (teaser, i) {
              teaser.hidden = i < (page - 1) * size || i >= page * size;
            });
            buttons.forEach(function (button, i) {
              var current = i + 1 === page;
              button.parentNode.classList.toggle("is-active", current);
              if (current) {
                button.setAttribute("aria-current", "page");
              } else {
                button.removeAttribute("aria-current");
              }
            });
            status.textContent = Drupal.t("Page @page of @total", {
              "@page": page,
              "@total": total,
            });
          }

          for (var page = 1; page <= total; page++) {
            var item = document.createElement("li");
            item.className = "pager__item";

            var button = document.createElement("button");
            button.type = "button";
            button.textContent = page;
            button.setAttribute(
              "title",
              Drupal.t("Go to page @page", { "@page": page }),
            );
            button.addEventListener("click", show.bind(null, page));

            item.appendChild(button);
            // The items are inline-block, so Twig-rendered pagers get part of
            // their spacing from the whitespace between tags. Match it.
            if (list.childNodes.length) {
              list.appendChild(document.createTextNode(" "));
            }
            list.appendChild(item);
            buttons.push(button);
          }

          items.parentNode.insertBefore(nav, items.nextSibling);
          nav.parentNode.insertBefore(status, nav.nextSibling);
          show(1);
        },
      );
    },
  };
})(Drupal, once);
